module.exports = __webpack_public_path__ + "img/techies_alt1.de75de44.png";